<template>
  <form-field
    :field="formField"
    :readonly="false"
    :validations="validations"
    @fieldChange="fieldChange"
  ></form-field>
</template>

<script>
import FormField from "../../objs/Shared/FormField";

export default {
  props: ["question"],
  computed: {
    validations: function () {
      if (this.question) {
        return this.question.mappedValidationPluginProps;
      }

      return {};
    },
    value: function () {
      return this.$store.getters["notesModule/getQuestionResponseValue"](
        this.question.questionId || ""
      );
    },
    formField: function () {
      return new FormField({
        label: this.question.label,
        value: this.value,
        componentName: this.question.componentName,
        options: this.question.options,
        itemText: "option",
        comparatorValue: "questionOptionId",
        outlined: true,
        column: this.question.columnLayout,
      });
    },
    templateNoteId() {
      return this.$store.state.notesModule.selectedTemplateNote?.templateNoteId;
    },
    questionResponse() {
      return this.$store.getters["notesModule/getQuestionResponse"](
        this.question.questionId || ""
      );
    },
  },
  methods: {
    async fieldChange(event) {
      await this.$store.dispatch("notesModule/setQuestionResponse", {
        questionResponseId: this.questionResponse?.questionResponseId,
        templateNoteId: this.templateNoteId,
        questionId: this.question.questionId,
        response: !event.isImage && !Array.isArray(event) ? event : null,
        selections: !event.isImage && Array.isArray(event) ? event : [],
        imageResponse: event.isImage ? event.imageURI : null,
      });
    },
  },
};
</script>
